
<template>
<div class="row">
  <div class="flex md3 xs3">
    <va-card class="tamanho_avisoa">
    <p class="text-center display-3">Disciplinas</p>
         <hr>
      <div v-for="(lista_disciplinas,index) in allMateriasProfessor" :key="index"  class="d-flex justify--center mt-3">
        <va-button type="submit" @click="mudar_disciplina(lista_disciplinas)"  color="info"  class="my-0 tamanho">{{lista_disciplinas.nome_disciplina}}</va-button>
      </div>
  </va-card>
  </div>
  <div class="flex md4 xs4 ">
        <va-card class="tamanho_avisoa">
        <div>
          
          <p class="display-3 text-center">Bienvenido</p>
        </div>
        <hr>

          <va-card class="tamanho_avisos display-5 my-2 text-center"  >
               <p display-3 text-center>{{disciplina.nome}}</p>
            </va-card>
      
        </va-card>
      
       
  </div>
       <div class="flex md5 xs5 tamanho_avisoa">
      

         <va-card class="scroll tamanho_avisoa">
            <div>
               <p class="display-3 text-center">Avisos</p>
            </div>
             <hr>

             <chatrespostas v-model="avisos"/>
                   
         </va-card> 
      
       
  </div>
  <!-- <div class=" flex row">
      <div class="flex md12 xs12" >
     
          <va-card  v-if="allArquviosVideos != ''">
            <div>
              
              <p  class="display-3 text-center">Videos</p>
            </div>
            <hr>

            <va-data-table
            :fields="getlista"
            :data="allArquviosVideos"
            hoverable
            no-pagination
            > 
                <template slot="marker" slot-scope="props">
                  <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
                </template>
                <template  slot="actions" slot-scope="props">
                  <va-button  small color="blurple" @click="edit(props.rowData)" class="ma-0">
                    Mirar
                  </va-button>
                
                  <va-button  small color="info" @click="download_arquivo(props.rowData)" class="ma-0">
                    Download
                  </va-button>


                </template>
                
            </va-data-table>
              
            </va-card>
          
       
          <va-card class="my-2" v-if="allArquviosSlides != ''">
            <div>
              
              <p  class="display-3 text-center">Slides</p>
            </div>
            <hr>

            <va-data-table
            :fields="getlista"
            :data="allArquviosSlides"
            hoverable
            no-pagination
            > 
                <template slot="marker" slot-scope="props">
                  <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
                </template>
                <template  slot="actions" slot-scope="props">
                  <va-button  small color="blurple" @click="edit(props.rowData)" class="ma-0">
                    Mirar
                  </va-button>
                
                  <va-button  small color="info" @click="download_arquivo(props.rowData)" class="ma-0">
                    Download
                  </va-button>


                </template>
                
            </va-data-table>
              
            </va-card>
         
      
          <va-card class="my-2" v-if="allArquviosAudios != ''">
            <div>
              
              <p  class="display-3 text-center">Audios</p>
            </div>
            <hr>

            <va-data-table
            :fields="getlista"
            :data="allArquviosAudios"
            hoverable
            no-pagination
            > 
                <template slot="marker" slot-scope="props">
                  <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
                </template>
                <template  slot="actions" slot-scope="props">
                  <va-button  small color="blurple" @click="edit(props.rowData)" class="ma-0">
                    Mirar
                  </va-button>
                
                  <va-button  small color="info" @click="download_arquivo(props.rowData)" class="ma-0">
                    Download
                  </va-button>


                </template>
                
            </va-data-table>
              
            </va-card>
         
     
          <va-card class="my-2" v-if="allArquviosExtras != ''">
            <div>
              
              <p  class="display-3 text-center">Extras</p>
            </div>
            <hr>

            <va-data-table
            :fields="getlista"
            :data="allArquviosExtras"
            hoverable
            no-pagination
            > 
                <template slot="marker" slot-scope="props">
                  <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
                </template>
                <template  slot="actions" slot-scope="props">
                  <va-button  small color="blurple" @click="edit(props.rowData)" class="ma-0">
                    Mirar
                  </va-button>
                
                  <va-button  small color="info" @click="download_arquivo(props.rowData)" class="ma-0">
                    Download
                  </va-button>


                </template>
                
            </va-data-table>
              
            </va-card>
          
  
      </div>
     
  </div> -->



</div>


</template>

<script>
export default {
  
    data () {
      return {

         disciplina: {
            
            nome:''
          },
         videos: {
            id: this.$store.state.datamateria.setmateria.id,
            tipo_arquivo_id: 1,
          },
          slides: {
            id: this.$store.state.datamateria.setmateria.id,
            tipo_arquivo_id: 2,
          },
          audios: {
            id: this.$store.state.datamateria.setmateria.id,
            tipo_arquivo_id: 3,
          },
          extras: {
            id: this.$store.state.datamateria.setmateria.id,
            tipo_arquivo_id: 5,
          },
        
        avisos: [
          {
            nome: 'teste',  
            pergunta: 'Hello! So glad you liked my work. Do you want me to shoot you jdsaugh dsaough asldijhg jas dgkh asd oasdjg ?',
            resposta: 'cjbhzjdbflkjsbdkjbfksjdnkjfnsj',
            yours: false,
          },
          {
            nome: 'teste2',  
            pergunta: 'Yeah, that would be cool. Maybe this Sunday at 3 pm?',
            resposta: 'cjbhzjdbflkjsbdkjbfksjdnkjfnsj',
            yours: true,
          },
          {
            nome: 'teste3',  
            pergunta: 'Sounds great! See you later!',
            resposta: 'cjbhzjdbflkjsbdkjbfksjdnkjfnsj',
            yours: false,
          },
          
        ],
      }
  },
  created(){
      this.all();
    },
  computed: {
    
     allMateriasProfessor (){ return   this.$store.state.professor.allMateriasProfessor },
    allArquviosVideos (){ return this.$store.state.arquivos.allArquivosVideos },
    allArquviosSlides (){ return this.$store.state.arquivos.allArquivosSlides   },
    allArquviosAudios (){ return this.$store.state.arquivos.allArquivosAudios   },
    allArquviosExtras (){ return this.$store.state.arquivos.allArquivosExtras   },
    getlista () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name: 'nome_arquivo',
          title: this.$t('tables.headings.name'),
        }, {
          name: 'status',
          dataClass: 'text-right',
          title: 'Status',
         
        }, {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
    },
    
  },
  methods: {
    all() {
      this.$store.dispatch('allArquivosPaginaInicial',this.videos)
      this.$store.dispatch('allArquivosPaginaInicial',this.slides)
      this.$store.dispatch('allArquivosPaginaInicial',this.audios)
      this.$store.dispatch('allArquivosPaginaInicial',this.extras)

      this.$store.dispatch('allMateriasProfessor',this.$store.state.professor.setProfessor.id)
      this.disciplina.nome =  this.$store.state.datamateria.setmateria.nome_disciplina
      console.log(this.disciplina)
    },
   async mudar_disciplina(value){
       
      await this.$store.dispatch('setMateria',value)
      
      this.all();

    },
    
    download_arquivo(value) {
    
      this.$store.dispatch('downloadArquivo',value)
      
    },
    
  }
}
</script>

<style scoped>

.tamanho {
  width: 100%;
  
}
.tamanho_avisos {
  width: 100%;
}
.tamanho_avisoa {
 min-height: 300px;
 max-height: 300px;
}
.scroll{
  overflow-y: scroll;
  max-height: 480px;

}

</style>